import ProductsHelper from '../components/ProductsHelper'
import Accessories from './Accessories';
class ServiceCallValidation {

    static isNullOrEmpty(v) {
        return v === "" || v === null;
    }
    static hasPAO(bon) {
        return bon.serviceCall.businessPartner.professionalAlarmFollowUp.code !== "" &&
            bon.serviceCall.businessPartner.professionalAlarmFollowUp.code !== "GEEN";
    }
    static getError(bon, changes) {

        var bp = bon.serviceCall.businessPartner;
        var isFirstSave = (bon.serviceCall.status === 1 || bon.serviceCall.status === 3 || bon.serviceCall.status === 13);
        var isPlaatsing = bon.serviceCall.problemType === 1;
        var isPlaatsingPA = isPlaatsing && 
            (bon.serviceCall.problemSubType === 1 ||  // basis
            bon.serviceCall.problemSubType === 2 ||  // flexibel
            bon.serviceCall.problemSubType === 33 || // flexibel actie
            bon.serviceCall.problemSubType === 3);   // zonder grenzen

        // check if we have orderlines left on the order
        var originalLineCount = 0
        if (bon.orders!==null) originalLineCount= bon.orders.reduce((a, b) => a + b.lines.length, 0);
        var newLineCount = originalLineCount +
            (changes.state.productsAdded ? changes.state.productsAdded.length : 0) -
            (changes.state.productsRemoved ? changes.state.productsRemoved.length : 0);

        if (bon.orders!==null && isFirstSave && newLineCount === 0) {
            return "Er zijn geen regels op de order. Ga naar het tabblad 'Acties' -> Additionele producten om minimaal 1 regel te selecteren.";
        }

        if (isFirstSave && changes.state.timeStart > new Date()) {
            return "Het is niet mogelijk om een starttijd in de toekomst op te geven. Controleer op het tabblad 'Acties'";
        }


        // check if there is a required SK to be installed, this is when there is a "plaatsing"
        if (isFirstSave && ServiceCallValidation.skRequired(bon.orders, changes) && isPlaatsing) {
            return "Er is geen KEK voor toegangsbeheer geinstalleerd, maar deze wordt wel verwacht volgens de order regels. Controleer op het tabblad 'Acties'";
        }

        // we expect at least one KEK when we have a "plaatsing"
        if (isFirstSave && changes.state.equipmentAdded !== null && changes.state.equipmentAdded.length===0 && isPlaatsingPA) {
            return "Er is geen enkele KEK toegevoegd, maar dit is een plaatsingsopdracht dus er wordt wel een KEK verwacht. Controleer op het tabblad 'Acties'";
        }


        // determine actions on keysafe (and afstandsbediening)
        var keySafeOnOriginalBon = bon.orders !== null && bon.orders.some(order => order.lines.some(line => line.item.code === "SA00156" || line.item.code === "SA00159" || line.item.code === "SA00162"));
        var keySafeAdded = changes.state.productsAdded !== null && changes.state.productsAdded.some(p => p.item.code === "SA00156" || p.item.code === "SA00159" || p.item.code === "SA00162");
        var keySafeRemoved = (changes.state.productsRemoved !== null && !changes.state.productsRemoved.some(p => p.item.code === "SA00156" || p.item.code === "SA00159" || p.item.code === "SA00162"));

        // check if we have added a "keysafe koop", we want to give a message when :
        // - keysafe item was not added and not existed on originalbon
        // - keysafe item was removed and existed on originalbon
        if (isFirstSave && changes.state.equipmentAdded.some(p => p.item.isHomeAccess && p.status === 'A') &&
            (
                (!keySafeOnOriginalBon && !keySafeAdded) ||
                (keySafeOnOriginalBon && keySafeRemoved)
            )
        ) {
            return "Er is een KEK voor een gekochte sleutelkluis/afstandsbediening toegevoegd, maar er ontbreekt een order regel om de kosten hiervoor in rekening te brengen (SA00156 of SA00159 of SA00162). Controleer op het tabblad 'Acties', bij additionele producten.";
        }

        // check if we have answered the keyPlaced question
        if (isFirstSave && changes.state.equipmentAdded.some(p => p.item.isHomeAccess) && !(changes.state.keyPlaced > 0)) {
            return "De vraag of de sleutel is achtergelaten dient nog beantwoord te worden. Controleer op het tabblad 'Acties'";
        }

        // check that we cannot have more than 1 PA device installed
        if (changes.state.equipmentAdded.filter(p => !p.item.isHomeAccess).length > 1) {
            return "Er zijn meerdere KEK's voor personenalarm opgegeven. Controleer op het tabblad 'Acties'";
        }

        // check that we have confirmed "no pacemaker" for added collierzender
        var originalCollier = bp.productCountersRent.collierzenders;
        var requestedCollier = originalCollier;
        if (changes.state.accessories && changes.state.accessories.hasOwnProperty("collierzenders")) requestedCollier = changes.state.accessories["collierzenders"];
        if (!changes.state.confirmedNoPaceMaker && isFirstSave) {
            // we have not confirmed that there is no pacemaker. It is necessary to do this in the following cases:
            if ((requestedCollier > 0 && requestedCollier > originalCollier) ||                                // we are adding a collier
                (originalCollier > 0 && isPlaatsing && requestedCollier > 0)           // or this is a "plaatsing" and originally we configured at least 1 collier to be  install, and we are still installing a collier
            ) {
                return "Bevestig dat de klant geen pacemaker heeft bij gebruik van de collierzender. Controleer op het tabblad 'Acties'";
            }
        }

        // check that when all accessories are 0, we must comfirm this
        var accessories=Accessories.GetAccessories(bp, changes);
        var countAccessories=accessories.reduce((a,v)=> a=a+parseInt(v.value), 0);
        if (countAccessories===0 && isFirstSave && !changes.state.confirmedNoAccessories) {
            return "Bevestig dat er geen enkele accessoire bij de klant staat. Controleer op het tabblad 'Acties'";
        }

        // check if PA is installed and a MB-code is supplied
        if (changes.state.equipmentAdded.some(p => !p.item.isHomeAccess) &&
            (changes.state.mbcode2 === "" ||              // case 1 : we are explicitly emptying the code
                (bp.reportingCenterCode2 === "" && ServiceCallValidation.isNullOrEmpty(changes.state.mbcode2)))   // case 2: there is no code and no change was made

        ) {

            return "Er moet een meldbank code opgegeven worden bij installatie personenalarm. Controleer op het tabblad 'Acties'";
        }

        return null;
    }

    static isSkOrderItem(code) {
        return ["PA-023", "PA-042", "PA-044", "PA-046", "PA-253", "PA-250", "PA-259", "SA00156", "SA00159"].some(p => p === code)
    }

    // when not installing any KEK for homeaccess, check if there is product on the order that requires SK
    static skRequired(orders, changes) {
        // check if a KEK for homeaccess was already specified, if so then it is no longer required
        if (changes.state.equipmentAdded !== null && changes.state.equipmentAdded.some(p => p.item.isHomeAccess)) return false;

        // check if there is an order, when there is no order, then no KEK is required
        if (!orders) return false;

        // check all lines of the first order, if there is a product that requires SK installation
        const products = ProductsHelper.Get(orders, changes.state);

        console.log("products", products);

        return products.some(p => this.isSkOrderItem(p.item.code));
    }


}

export default ServiceCallValidation;